export function fixTZ(tz: string): string {
  if (tz === 'America/Indianapolis') {
    return 'America/Indiana/Indianapolis';
  }
  return tz;
}
